// extracted by mini-css-extract-plugin
export default {"buttonWrap":"ConversionRateSettings_buttonWrap__ogvHh","cancelBtn":"ConversionRateSettings_cancelBtn__g1pQZ"};